import React, { forwardRef } from 'react';
import { Box } from '../Box';
import { useStyles } from './Spacer.styles';
import { SpacerProps } from './Spacer.types';

/**
 * Spacer component.
 * Serves as a wrapper component with flex properties.
 */
export const Spacer = forwardRef<HTMLDivElement, SpacerProps>(
  ({ centered, children, className, direction, gap, style }: SpacerProps, ref): JSX.Element => {
    const classes = useStyles({ centered, direction, gap, style });

    return (
      <Box ref={ref} className={`${classes.wrapper} ${className}`}>
        <>{children}</>
      </Box>
    );
  },
);

Spacer.defaultProps = {
  centered: false,
  children: null,
  className: '',
  direction: 'horizontal',
  gap: 's',
  style: {},
};
